'use client'

import { useEffect, useState } from 'react'
import { Modal } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

const HIDE_KEY = 'ktp-thankyou-hide-until'

const AnnouncementPopup = () => {
  const isMobile = useMediaQuery('(max-width: 1279px)')
  const [opened, setOpened] = useState(false)

  useEffect(() => {
    const hideUntil = localStorage.getItem(HIDE_KEY)
    if (hideUntil === 'forever') return
    setOpened(true)
  }, [])

  const handleHideForever = () => {
    localStorage.setItem(HIDE_KEY, 'forever')
    setOpened(false)
  }

  const handleClose = () => setOpened(false)

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      size={isMobile ? 'calc(100vw - 32px)' : '480px'}
      styles={{
        inner: { padding: 0 },
        content: {
          background: '#0E1422',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.45)',
        },
        body: { padding: 0 },
        overlay: { backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(2px)' },
      }}
    >
      <div className="flex flex-col">
        <div className="flex flex-col items-center gap-5 px-6 py-10 pc:gap-6 pc:px-12 pc:py-14">
          <span className="rounded-full border border-[#3385FF]/40 bg-[rgba(51,133,255,0.12)] px-3 py-1 text-xs font-medium text-[#7AB0FF] pc:text-sm">
            Congrats to the Top 20 teams
          </span>
          <h2 className="break-keep text-center text-2xl font-bold leading-snug text-white pc:text-3xl">
            2026년 K-TECH PIONEERS
            <br />
            최종 선발 20개팀이 확정되었습니다.
          </h2>
          <div className="flex flex-col items-center gap-1 pc:gap-1.5">
            <p className="break-keep text-center text-sm font-medium text-white/85 pc:text-base">
              선정된 팀들의 한국에서의 새로운 도전을 응원합니다.
            </p>
            <p className="break-keep text-center text-sm font-medium text-white/85 pc:text-base">
              또한 본 프로그램에 관심을 가지고 지원해주신
            </p>
            <p className="break-keep text-center text-sm font-medium text-white/85 pc:text-base">
              모든 참가팀 여러분께 진심으로 감사드립니다.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 border-t border-white/10">
          <button
            type="button"
            onClick={handleHideForever}
            className="py-4 text-xs text-white/60 transition-colors hover:bg-white/5 hover:text-white pc:text-sm"
          >
            다시 보지 않기
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="border-l border-white/10 py-4 text-xs text-white transition-colors hover:bg-white/5 pc:text-sm"
          >
            닫기
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default AnnouncementPopup
